// Importing necessary action type constants
import * as ACTION from '../../Redux.constants';

/**
 * NotebookDrawerReducer
 * A reducer function to manage the state of the notebook drawer's collapse status.
 * 
 * @param {boolean} state - Represents the current state of the notebook drawer's collapse status. 
 *                          Initially set to false, indicating the drawer is not collapsed.
 * @param {Object} action - Represents the dispatched action.
 * @returns {boolean} - Returns the new state of the notebook drawer's collapse status based on the action.
 */
export function NotebookDrawerReducer(state = false, action) {
  switch (action.type) {
    // When the collapse status is set, update the state with the payload value.
    case ACTION.SET_COLLAPSE:
      return action.payload;

    // For any other action, simply return the current state.
    default:
      return state;
  }
}
